/**
 * @exports MapChart
 * @fileoverview this file define the MapChart component 
 * @date 2022-08-23
 * @version 1.0 
 * @author Combes Hugo
 */

/*Import necessaries librairies*/

import React, { Component } from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
  Sphere,
  Graticule,
  Marker
} from "react-simple-maps";
import { Text, Paper, Grid } from '@mantine/core';
import { IconArrowBackUp } from '@tabler/icons';
import { Button } from '@mantine/core';
import {gsap} from 'gsap';


class MapChart extends Component{
    constructor(props) {
        super(props);
        this.comp = React.createRef();
        this.animate = this.animate.bind(this);
        this.state = {
            hover:false,
            zoomLevel:200, //1 for World, 2 for Europe, 3 for America !
            mapLevel:1, //1 for World, 2 for Europe, 3 for America !
            mapRotation: [-10.0, -50.0, 0], //defaut values : [-10.0, -50.0, 0],
            hoveringCountryName:"",
            animationTime: 0,
            intervalId: null,
        };
    }

    componentDidMount() {
        this.animate()
        this.startTimer()
      }

      componentWillUnmount() {
        this.revert();
      }

      startTimer = () => {
        const intervalId = setInterval(() => {
          this.setState(prevState => ({
            animationTime: prevState.animationTime + 1,
          }));
        }, 1000);
        this.setState({ intervalId });
        setTimeout(() => {
          clearInterval(intervalId);
        }, 7000);
      };

      animate(){
        setTimeout(() => {
            let ctx = gsap.context(() => {
                gsap.from('.theState', {
                    duration: 3,
                    stagger: 0.02,
                    ease: 'back',
                    y: 96,
                    opacity: 0,
                  });
                  let tl = gsap.timeline();
                  tl.to('.theCountry', {
                    delay: 5.4,
                    fill: '#FF331F',
                    duration: 0.8,
                  });
                  tl.to('.theCountry', {
                    fill: 'grey',
                  });
                  tl.to('.theCountry', {
                    delay: 0.4,
                    fill: '#FF331F',
                    duration: 0.8,
                  });
                  tl.to('.theCountry', {
                    fill: 'grey',
                  });
            }, this.comp.current);
        
            this.revert = () => ctx.revert();
            }, 500);
        }

    render(){   
        const geoUrl = "/maps/features.json";
        let data = this.props.data
        let city = this.props.city

        function getListMarker(state,zoomLevel,countryList){
            let divContent = []
            if(zoomLevel===600 || zoomLevel===1200){
                for(let i = 0; i < data.length ; i++){
                    if(data[i].Variable === "France"){
                        divContent.push(<>{getMarker(723, 766,"France", data[i].Count,state)}</> );
                    }
                    if(data[i].Variable === "Belgique"){
                        divContent.push(<>{getMarker(725.8, 771,"Belgique", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "Espagne"){
                        divContent.push(<>{getMarker(717, 761,"Espagne", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "Angleterre"){
                        divContent.push(<>{getMarker(719, 773,"Angleterre", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "Italie"){
                        divContent.push(<>{getMarker(732, 762.5,"Italie", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "Allemagne"){
                        divContent.push(<>{getMarker(731, 772.5,"Allemagne", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "Suisse"){
                        divContent.push(<>{getMarker(728.5, 767,"Suisse", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "Suède"){
                        divContent.push(<>{getMarker(734, 778,"Suède", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "États-Unis"){
                        divContent.push(<>{getMarker(88, 142,"États-Unis", data[i].Count,state)}</>);
                    }
                    if(data[i].Variable === "Canada"){
                        divContent.push(<>{getMarker(78, 122,"Canada", data[i].Count,state)}</>);
                    }
                }
                return(divContent)
            } 
            if(zoomLevel===200){
                let numberPerContinent = getNumberContinent(countryList)
                divContent.push(<>{getMarker(88, 142,"Amérique", numberPerContinent[1],state)}</>);
                divContent.push(<>{getMarker(723, 776,"Europe", numberPerContinent[0],state)}</>);
                divContent.push(<>{getMarker(9, 18,"Afrique", numberPerContinent[2],state)}</>);
                divContent.push(<>{getMarker(56, 35,"Asie", numberPerContinent[3],state)}</>);
                return(divContent)
            }
            if(zoomLevel===3600){
                divContent.push(<>{getMarker(-1.55, 47.2,"Nantes", city[0],"state",zoomLevel)}</>);
                divContent.push(<>{getMarker(5.5, 43.53,"Aix-en-Provence", city[1],"state",zoomLevel)}</>);
                divContent.push(<>{getMarker(4.84, 45.75,"Lyon", city[2],"state",zoomLevel)}</>);
                divContent.push(<>{getMarker(2.33, 48.86,"Paris", city[3],"state",zoomLevel)}</>);
                divContent.push(<>{getMarker(5.38, 43.29,"Marseille", city[4],"state",zoomLevel)}</>);
                divContent.push(<>{getMarker(1.43, 43.6,"Toulouse", city[5],"state",zoomLevel)}</>);
                divContent.push(<>{getMarker(3.05, 50.6,"Lille", city[6],"state",zoomLevel)}</>);
                return(divContent)
            }
            else {
                return(<></>)
            }
        }

        function translate(country){
            if(country === "Spain"){
                return("Espagne")
            }
            if(country === "United Kingdom"){
                return("Angleterre")
            }
            if(country === "Spain"){
                return("Espagne")
            }
            if(country === "Netherlands"){
                return("Belgique")
            }
            if(country === "Germany"){
                return("Allemagne")
            }
            if(country === "Italy"){
                return("Italie")
            }
            if(country === "Sweden"){
                return("Suède")
            }
            if(country === "Switzerland"){
                return("Suisse")
            }
            if(country === "United States of America"){
                return("États-Unis")
            }
            else {
                return(country)
            }
        }

        function getMarker(x,y,title,count,state,zoomLevel){
            let scaleX = 1 + 0.0018*count
            let hoveringCountry = "" //= title
            let paperSizeX = 45 
            let paperSizeY = 45
            let city = ""
            let superpositionOffSet = 0 //for when 2 city/country are to close
            if (title === translate(state.hoveringCountryName)){
                //is hovered !
                hoveringCountry = title
                paperSizeX = 85 
                paperSizeY = 65
            }
            if(zoomLevel === 3600){
                city = title
                paperSizeX = 85 
                paperSizeY = 65
                if (city === "Aix-en-Provence") {
                    superpositionOffSet = 30
                    paperSizeY = 90
                }
            }
            return(
                <Marker key={title} className='theMarkers' coordinates={[x - 0.6*scaleX*scaleX, y + 0.25*scaleX*scaleX]}     >
                    <foreignObject x={-12 +12*scaleX+superpositionOffSet} y={-11 +12*scaleX-2*superpositionOffSet} width={paperSizeX} height={paperSizeY}>
                            <Paper radius="lg" p="xs" withBorder>
                                <Text size="sm">{hoveringCountry}{city}</Text>
                                <Text size="sm" >{count}</Text>
                            </Paper>
                    </foreignObject>
                    <g
                        fill="none"
                        stroke="#FF5533"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform={`translate(-12, -24) scale(${scaleX})`}
                    >
                        <circle cx="12" cy="10" r="3" />
                        <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
                    </g>
                </Marker>
            )
        }

        function handleZoomFranceOrContinent(pays,continent,zoom){
            if (pays==='France' && zoom === 1200){
                return([3600,[-2.0, -47.0, 0]])
            } else {
                return(handleZoom(continent))
            }
        }

        function handleZoom(continent){
            if (continent === "Europe"){
                return([1200,[-10.0, -50.0, 0]])
            } 
            if (continent === "North America") {
                return([600,[100.0, -45.0, 0]])
            }
            else return ([200,[-10.0, -50.0, 0]])
        }

        function getNumberContinent(countryList){
            let continentList = [ ["Europe","Amérique du nord","Afrique","Asie"],[0,0,0,0] ]
            for(let i = 0; i < countryList.length; i++){
                if(countryList[i].Variable==="France" || countryList[i].Variable==="Belgique" || countryList[i].Variable==="Espagne" || countryList[i].Variable==="Angleterre" || countryList[i].Variable==="Italie" || countryList[i].Variable==="Allemagne" || countryList[i].Variable==="Suisse" || countryList[i].Variable==="Royaume-Uni" || countryList[i].Variable==="Suède" || countryList[i].Variable==="Italy" ) {
                continentList[1][0] = continentList[1][0] + countryList[i].Count
                }
                if (countryList[i].Variable==="Canada" || countryList[i].Variable==="États-Unis" || countryList[i].Variable==="Etats-Unis" ){
                continentList[1][1]=continentList[1][1]+countryList[i].Count
                }
                if(countryList[i].Variable==="Maroc"){
                continentList[1][2]=continentList[1][2]+countryList[i].Count
                }
                if(countryList[i].Variable==="Israel"){
                continentList[1][3]=continentList[1][3]+countryList[i].Count
                }
            }
            return( continentList[1] )
        }
        
        let index = 0;

        return (
        <div >
            <Grid>
                {/* <Grid.Col span={2}>
                    {this.state.animationTime % 7 === 0 ? 
                    <>
                        <Button onClick={() => { this.animate(); this.startTimer(); }} leftIcon={<IconRefresh size="1rem" />}>
                            Animation
                        </Button>
                    </> : 
                    <>
                        <Button color="gray" leftIcon={<IconClockCancel size="1rem" />}>
                            Animation ...
                        </Button>
                    </>}
                </Grid.Col> */}
                <Grid.Col span={1} offset={1}>
                    {this.state.zoomLevel === 200 ? <></> : 
                    <>
                        <Button onClick={  () =>     this.setState({ zoomLevel : 200, mapRotation : [-10.0, -50.0, 0] })    } leftIcon={<IconArrowBackUp size="1rem" />}>
                            {this.props.translate("dashboard.chart.back")}
                        </Button> 
                    </>}         
                </Grid.Col>
            </Grid>
            
            <ComposableMap
                width={600}
                height={600}
                projection="geoAzimuthalEqualArea"
                projectionConfig={{
                rotate: this.state.mapRotation,  //europre : [-10.0, -50.0, 0] //america : [100.0, -45.0, 0]
                scale: this.state.zoomLevel
                }}
            >


                <Sphere stroke="#E4E5E6" strokeWidth={0.5} />
                <Graticule stroke="#E4E5E6" strokeWidth={0.5} />


                <Geographies geography={geoUrl} ref={this.comp} key="" fill="#1a1a1a" >
                    {(geoData) => { 
                    return (
                    <React.Fragment key={index}> 
                        {geoData.geographies.map((geo) => { 

                        return (
                            <Geography
                            onClick={() => { this.setState({ zoomLevel : handleZoomFranceOrContinent(geo.properties.name,geo.properties.continent,this.state.zoomLevel)[0], mapRotation : handleZoomFranceOrContinent(geo.properties.name,geo.properties.continent,this.state.zoomLevel)[1] }) } }
                            key={geo.rsmKey}
                            className='theState theCountry'
                            geography={geo}
                            fill="#9998A3"
                            onMouseEnter={ () => this.setState({ hoveringCountryName : geo.properties.name }) }
                            style={{
                                hover: {
                                fill: '#FF331F',
                                },
                            }}
                            />
                        );
                        })}
                    </React.Fragment>
                    )
                }}
                </Geographies>
                {getListMarker(this.state,this.state.zoomLevel,this.props.data)}
            </ComposableMap>
        </div>
        )
    }
}

  export default MapChart;

